export default __webpack_public_path__ + "static/media/ultra-rare.a3ba8dbf.png";